var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
          _vm.color === 'gray' ? 'bg-gray-200' : 'bg-white',
          _vm.disablePadding ? '' : 'p-4'
      ]},[(_vm.loading)?_c('div',{staticClass:"flex justify-center"},[_c('loading-svg-inline',{staticClass:"w-24 h-24"})],1):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }